var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "7px",
    viewBox: "0 0 22 7",
    style: {
      enableBackground: "new 0 0 22 7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,6C1.3,6,0.2,4.9,0.2,3.5S1.3,1,2.7,1s2.5,1.1,2.5,2.5S4.1,6,2.7,6z M11,6C9.6,6,8.5,4.9,8.5,3.5S9.6,1,11,1 s2.5,1.1,2.5,2.5S12.4,6,11,6z M19.3,6c-1.4,0-2.5-1.1-2.5-2.5S17.9,1,19.3,1c1.4,0,2.5,1.1,2.5,2.5S20.7,6,19.3,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotIcon);
export default __webpack_public_path__ + "static/media/three_dot_icon.adaf72e2aed55427105002fb513388dc.svg";
export { ForwardRef as ReactComponent };